import { Row, Col, Avatar, Typography, Card, Tag, Image } from "antd";
import { truncate } from "lodash";
import { DateTime } from "luxon";
import React from "react";

export default function Message(props) {
  const formatedDate = DateTime.fromISO(props.createdAt).toFormat(
    "dd.MM.yyyy HH:mm"
  );
  return (
    <Row
      id={`chat_item_${props.id}`}
      justify={props.fromContact ? "start" : "end"}
      style={{ flex: 1 }}
    >
      <Card
        style={{ width: "70%", margin: 5 }}
        styles={{
          body: { padding: 5 },
        }}
      >
        <Col>
          <Row align="middle" justify="start" gutter={1}>
            <Col>
              <Avatar src={props.user.avatar} size={22} />
            </Col>
            <Col offset={1}>
              <Typography.Text strong>
                {truncate(props.user.name.trim() || `User #${props.user.id}`)}
              </Typography.Text>
            </Col>
          </Row>
          <Row>
            <Col style={{ padding: "5px 0px" }}>
              <Typography.Text style={{ fontSize: 13 }}>
                {props.text}
              </Typography.Text>
            </Col>
          </Row>
          {props.image && <Image src={props.image} />}
          <Row>
            <Typography.Text type="secondary" style={{ fontSize: 10 }}>
              {formatedDate}
            </Typography.Text>
          </Row>
          <Row justify="start">
            {props.isOld && <Tag color="blue">old message</Tag>}
            {props.premiumPurchaseId && (
              <Tag color="orange">{props.premiumName}</Tag>
            )}
            {props.hasBooking && <Tag color="violet">booking</Tag>}
          </Row>
        </Col>
      </Card>
    </Row>
  );
}
